import Bowser from "bowser";

import { api, baseClient } from "@/api";
import { type Account, accountSchema } from "@/schemas";

import { getBaseURL, type App } from "./utils";

async function verifyCredentials(token: string): Promise<Account> {
  const browser = Bowser.getParser(window.navigator.userAgent);

  const { data } = await api().get<Account>(
    "/api/v1/accounts/verify_credentials",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Browser: browser.getBrowserName(),
        OS: browser.getOSName(),
      },
    },
  );

  return accountSchema.parse(data);
}

function revokeOAuthToken(params: App & { token: string }) {
  const baseURL = getBaseURL();

  return baseClient(null, baseURL).post("/oauth/revoke", params);
}

export { verifyCredentials, revokeOAuthToken };
